/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Refunded: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M16 4C19.5899 4 22.5 6.91015 22.5 10.5C22.5 14.0899 19.5899 17 16 17H6.12988L8.66406 19.2529L8.7373 19.3242C9.08027 19.6975 9.09109 20.277 8.74707 20.6641C8.40301 21.0511 7.82596 21.1085 7.41504 20.8115L7.33594 20.7471L2.83594 16.7471C2.62245 16.5573 2.5 16.2856 2.5 16C2.5 15.7144 2.62245 15.4427 2.83594 15.2529L7.33594 11.2529C7.74872 10.886 8.38015 10.9232 8.74707 11.3359C9.11399 11.7487 9.07685 12.3802 8.66406 12.7471L6.12988 15H16C18.4853 15 20.5 12.9853 20.5 10.5C20.5 8.01472 18.4853 6 16 6H12C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4H16Z'
      fill='currentColor'
    />
  </React.Fragment>
)
